import { useSelector, useDispatch } from "react-redux";
import { useMemo } from "react";
import {
  getPages,
  getOffset,
  getImageGalleryOnboardDismissed,
  selectSearchIsNewPage,
  selectSearchIsInitialLoading,
  selectSearchIsPagingBackward,
  selectSearchShowLoadMore,
  selectSearchShowLoadPrevious,
  selectSearchTileToFocus,
  updateImageGalleryOnboardDismissed,
} from "../../../../../state/modules/search";
import { isErrorOfTypeServer as getIsErrorOfTypeServer } from "../../../../../state/modules/error";
import Results from "../../../Results";
import { getPlatform } from "../../../../../state/modules/config/selectors";
import { getCategoryTreatments } from "../../../../../state/modules/category";

const ConnectedResults = (props) => {
  const dispatch = useDispatch();

  const pages = useSelector(getPages);
  const offset = useSelector(getOffset);
  const isErrorOfTypeServer = useSelector(getIsErrorOfTypeServer);
  const isNewPage = useSelector(selectSearchIsNewPage);
  const isLoading = useSelector(selectSearchIsInitialLoading);
  const isLoadingPrevious = useSelector(selectSearchIsPagingBackward);
  const showLoadMore = useSelector(selectSearchShowLoadMore);
  const showLoadPrevious = useSelector(selectSearchShowLoadPrevious);
  const tileToFocus = useSelector(selectSearchTileToFocus);
  const imageGalleryOnboardDismissed = useSelector(
    getImageGalleryOnboardDismissed,
  );
  const platform = useSelector(getPlatform);
  const categoryTreatments = useSelector(getCategoryTreatments);

  const memoizedProps = useMemo(
    () => ({
      ...props,
      pages,
      isErrorOfTypeServer,
      isLoading,
      isNewPage,
      isLoadingPrevious,
      showLoadMore,
      showLoadPrevious,
      tileToFocus,
      offset,
      imageGalleryOnboardDismissed,
      platform,
      categoryTreatments,
      updateImageGalleryOnboardDismissed: (args) =>
        dispatch(updateImageGalleryOnboardDismissed(args)),
    }),
    [
      props,
      pages,
      isErrorOfTypeServer,
      isLoading,
      isNewPage,
      isLoadingPrevious,
      showLoadMore,
      showLoadPrevious,
      tileToFocus,
      offset,
      imageGalleryOnboardDismissed,
      platform,
      categoryTreatments,
      dispatch,
    ],
  );

  return <Results {...memoizedProps} />;
};

export default ConnectedResults;
